/**
 * main.js
 *
 * Bootstraps Vuetify and other plugins then mounts the App`
 */

// Plugins
import { registerPlugins } from "@/plugins";
import SuperTokens from "supertokens-web-js";
import Session from "supertokens-web-js/recipe/session";
import EmailPassword from "supertokens-web-js/recipe/emailpassword";
import "unfonts.css";

// Components
import App from "./App.vue";

// Composables
import { createApp } from "vue";

const app = createApp(App);

registerPlugins(app);

SuperTokens.init({
    appInfo: {
        apiDomain: window.location.origin,
        apiBasePath: "/api/auth",
        appName: "Nebulone",
    },
    recipeList: [
        EmailPassword.init(),
        Session.init({
            tokenTransferMethod: "cookie",
        }),
    ],
});

app.mount("#app");
